import { useState } from 'react';

import { useI18n } from '@openclassrooms/translations/I18nProvider';
import ContentDialog from '@classify/react-core-components/ContentDialog';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export type PageType = 'main' | 'phone';

export function useDialog(defaultOpen = false) {
  const [isDialogOpen, setIsDialogOpen] = useState(defaultOpen);
  const [currentPage, setCurrentPage] = useState<PageType>('main');

  const handleGoMain = () => {
    setCurrentPage('main');
  };

  const handleChangePage = (newPage: PageType) => {
    setCurrentPage(newPage);
  };

  const handleOpen = () => {
    setIsDialogOpen(true);
  };

  const handleClose = () => {
    setIsDialogOpen(false);
    setCurrentPage('main');
  };

  return {
    currentPage,
    handleChangePage,
    handleGoMain,
    isDialogOpen,
    handleOpen,
    handleClose,
  };
}

export default function Dialog({ isOpen, onClose, children }: Props) {
  const { translate } = useI18n();

  return (
    <>
      <ContentDialog
        translations={{ closeButtonLabel: translate('global.action.close_button') }}
        isSide
        isOpen={isOpen}
        onClose={onClose}
        background="alternative"
      >
        {children}
      </ContentDialog>
    </>
  );
}
